<app-navigation/>

<div class="container-fluid">
    <div class="row">
        <app-sidebar/>

        <main class="col-sm-12">
            <router-outlet/>
        </main>
    </div>
</div>
